<template>
    <div class="block-progress">
        <span class="block-progress__title">
            Интересы <br> и развитие
        </span>
        <p class="block-progress__text">
            В 12–13 лет увлечения меняются часто и быстро. Химия и другие науки приходят на смену спорту и танцам, рукоделие — музыке, кулинария — влогу на&nbsp;YouTube. И&nbsp;это абсолютно нормально. Сильное увлечение определенным стилем музыки тоже признак пубертата. Теперь на день рождения подросток просит наушники, музыкальную колонку или новый смартфон (с хорошей камерой!). А&nbsp;вместо героев мультиков обсуждает блогеров, количество их подписчиков и&nbsp;челленджи.
        </p>
        <div class="block-progress__img-box">
            <img
                srcset="../assets/1215-top.jpg, ../assets/1215-top@2x.jpg 2x"
                src="../assets/1215-top.jpg"
                class="block-progress__img"
            />
            <div class="image-caption image-caption--overlap-left" style="text-align:left">Двор-парк в проекте «Ильинские луга»</div>
        </div>
        <p class="block-progress__text block-progress--text-bottom">
            У ребенка появляется «своя компания». Причем не только в&nbsp;жизни, но и в интернете. Подросткам важно придерживаться правил какой-то субкультуры, быть частью группы. Отстаивать свои права, даже если это право не&nbsp;надевать шапку или ложиться спать после полуночи.
        </p>
        <BlockParallax class="block-progress__icon-box block-progress__cube" speed="10" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/ll-8.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__lego-yellow" speed="8" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/kk-2.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__lego-green" speed="10" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/hp-2.png"
                class="block-progress__icon"
            >
        </BlockParallax>

        <BlockParallax class="block-progress__icon-box block-progress__cube-two block-progress--icon-desktop" speed="10" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/ll-8.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__lego-yellow-two block-progress--icon-desktop" speed="6" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/ph-3.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__lego-green-two block-progress--icon-desktop" speed="8" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/hp-2.png"
                class="block-progress__icon"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-progress {
        position relative
        +layout-sm-and-up() {
            display flex
            padding 0
            flex-wrap wrap
        }
        +layout-md-and-up() {
            margin-left 8rem
        }

        &__title {
            display block
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-text
            +layout-sm-and-up() {
                text-align center
                width 100%
                padding-right 7%
                font-size 3rem
                line-height 3.5rem
            }
            +layout-md-and-up() {
                margin-top 2rem
                text-align left
                position absolute
                left 0
                padding-left 0
            }

            br {
                display none
                +layout-md-and-up() {
                    display block
                }
            }
        }

        &__img-box {
            margin 2rem -1rem 0

            +layout-sm-and-up() {
                width 100%
                margin-left 0
                margin-right 0
            }

            +layout-md-and-up() {
                width 100%
                margin 5rem 8rem 4rem 0
            }
        }

        &__img {
            width 100%
            height auto
        }

        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.7rem 0 0 0

            +layout-sm-and-up() {
                width 100%
            }

            +layout-md-and-up() {
                padding-left 25rem
                padding-right 14rem
            }
        }
        &--text-bottom {
            +layout-md-and-up() {
                padding-right 26rem
            }
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__lego-green {
            position absolute
            top 3%
            left -12%
            transform rotate(-44deg)
            width 7.6rem

            +layout-md-and-up() {
                left -11rem
                width 7.5rem
                top 13rem
            }
        }

        &__lego-green-two {
            +layout-md-and-up() {
                position absolute
                bottom 14rem
                right -4rem
                width 10rem
                height 9rem
            }
        }

        &__lego-yellow {
            position absolute
            right -2rem
            top 35rem
            transform rotate(47deg)
            width 6rem

            +layout-md-and-up() {
                right auto
                width 7.4rem
                height 8rem
                top auto
                bottom 10rem
                left -14rem
            }
        }

        &__lego-yellow-two {
            +layout-md-and-up() {
                position absolute
                right -8rem
                top 32rem
                width 8rem
            }
        }

        &__cube {
            position absolute
            bottom 22rem
            left -1rem
            width 4.5rem
            transform rotate(-54deg)
            +layout-md-and-up() {
                left 8rem
                bottom 4rem
                width 5rem
            }
        }

        &__cube-two {
            +layout-md-and-up() {
                position absolute
                right 1rem
                top 11rem
                width 4rem
            }
        }
    }
</style>
